import {
    CLIENT_PROFILE_INFO,
    CLIENT_REQUESTS,
    CHANGE_PASSWORD,
  } from "../config/api";
  import { IChangePasswordRequest } from "../models/cabinet";
  import { baseService } from "./BaseService";
  
  class CabinetService {
    public async getClientProfileInfo(): Promise<any> {
      return baseService.get(CLIENT_PROFILE_INFO);
    }
    public async getClientRequests(): Promise<any> {
      return baseService.get(CLIENT_REQUESTS);
    }
    public async changePassword(data: IChangePasswordRequest): Promise<any> {
      return baseService.post(CHANGE_PASSWORD, data);
    }
  }
  
  export const cabinetService = new CabinetService();
  